import { render, staticRenderFns } from "./ViewOne.vue?vue&type=template&id=06d84f48&scoped=true"
import script from "./ViewOne.vue?vue&type=script&lang=js"
export * from "./ViewOne.vue?vue&type=script&lang=js"
import style0 from "./ViewOne.vue?vue&type=style&index=0&id=06d84f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d84f48",
  null
  
)

export default component.exports